import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";

/**
 * /v/:code — Vermittler-Empfehlungs-Link Landing.
 * Records the click, stores the short-code in localStorage + cookie,
 * then redirects to the homepage. Invalid codes still redirect cleanly.
 */
function setReferralCookie(code) {
    const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `tw_ref=${encodeURIComponent(code)}; expires=${expires}; path=/; SameSite=Lax; Secure`;
    try { localStorage.setItem("tw_ref", code); } catch { /* private mode */ }
}

export default function ReferralLandingPage() {
    const { code } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const upper = (code || "").toUpperCase();
        // Best-effort click registration. Even if it fails we still set the cookie
        // locally so the buyer remains attributed.
        api.get(`/v/${upper}/click`)
            .catch(() => { /* silent */ })
            .finally(() => {
                setReferralCookie(upper);
                // Small UX delay so the spinner is visible — feels intentional.
                setTimeout(() => navigate("/", { replace: true }), 400);
            });
    }, [code, navigate]);

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-[#FFCC00]"
            data-testid="referral-landing"
        >
            <div className="bg-white border border-gray-200 rounded-sm p-8 text-center max-w-sm shadow-lg">
                <Loader2 className="w-8 h-8 animate-spin text-[#FFCC00] mx-auto mb-3" />
                <h1 className="font-display font-bold text-lg mb-1">Willkommen!</h1>
                <p className="text-sm text-gray-600">
                    Sie wurden von einem Vermittler eingeladen — wir leiten Sie auf
                    den TwoWheels-Marktplatz weiter…
                </p>
            </div>
        </div>
    );
}
